
<template>
    <loadingSpinner  v-if="loading" :loadingname="loadingname"/>
    <div class="space-y-4 px-8 bg-black" style="padding-bottom: 14%; padding-top: 2%;" v-if="!loading">
    <h2 class="text-xl text-white font-semibold" style="display: flex; justify-content: center;">Profile</h2>
    <fieldset class="fieldset">
            <label class="text-xl text-white font-semibold">Email ID</label>
            <input v-model="data.email" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="you@example.com" style="width: 100%; height: 3rem;" />            
            <span></span>
            <button ref="changeEmailBtn" autocomplete="off" name = "changeEmail" @click="changeEmail" class="rounded-md text-xl text-black font-semibold bg-white"  style="height: 2.75rem; width: 100%;">
            <span v-if="changingEmail" class="loading loading-dots loading-xl"></span>
            <span v-if="!changingEmail">Change Email</span>              
            </button>          
            <label class="text-xl text-white font-semibold" >Password</label>           
            <input minlength="8" maxlength="30" v-model="password" :type="showPassword ? 'text' : 'password'" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="••••••••" style="width: 100%; height: 3rem;" />
            <label class="text-lg text-white" @click="togglePassword">{{ showPassword ? 'Hide Password' : 'Show Password' }}</label>
            <button ref="changePasswordBtn" name = "changePassword" @click="changePassword" class="rounded-md text-xl text-black font-semibold bg-white"  style="height: 2.75rem; width: 100%;">
            <span v-if="changingPassword" class="loading loading-dots loading-xl"></span>
            <span v-if="!changingPassword">Change Password</span>      
            </button>          
            <span></span>
            <div v-if="data.work_email_verified" class="pt-2 text-white bg-black rounded-md" style="display: flex; justify-content: space-between; height: 2.75rem;">
            <img :src="`https://logo.clearbit.com/${data.company}`"   class="h-8 w-8 rounded-lg" alt="Logo" />
            <div class="flex flex-row" style="justify-content: space-between;" >      
            <svg class="size-[2rem]" xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" id="check-circle" data-name="Flat Line"><circle id="secondary" cx="12" cy="12" r="9" style="fill: rgb(35,134,54); stroke-width: 2;"/><polyline id="primary" points="8 12 11 15 16 10" style="fill: none; stroke: rgb(255,255,255); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/><circle id="primary-2" data-name="primary" cx="12" cy="12" r="9" style="fill: none; stroke: rgb(35,134,54); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/>
            </svg>
            <label class="flex text-xl font-semibold pl-2">{{data.company.split(".")[0].replace(/^./, c => c.toUpperCase())}}</label>
            </div>
            </div>
            <label class="text-xl text-white font-semibold">Work Email ID</label>
            <input v-show="!verify_with_key" autocomplete="off" v-model="work_email" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="you@google.com" style="width: 100%; height: 3rem;" />            
            <a v-show="!verify_with_key" class="text-lg link underline text-[#1a73e8] font-bold" @click="this.verify_with_key = !this.verify_with_key">Verify Using key</a>
            <button ref="verifyBtn" v-show="!verify_with_key" name = "verify" @click="verify" class="rounded-md text-xl text-white font-semibold bg-[#238636]"  style="height: 2.75rem; width: 100%;">
            <span v-if="verifying" class="loading loading-dots loading-xl"></span>
            <span v-if="!verifying">Verify</span>      
            </button>          
            <input v-show="verify_with_key" v-model="work_email_verification_key" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Verify With Key" style="width: 100%; height: 3rem;" />            
            <a v-show="verify_with_key" class="text-lg link underline text-[#1a73e8] font-bold" @click="this.verify_with_key = !this.verify_with_key">Verify Work Email</a>
            <button ref="verifyingKeyBtn" v-show="verify_with_key" name = "verifyKey" @click="verifyKey" class="rounded-md text-xl text-white font-semibold bg-[#238636]"  style="height: 2.75rem; width: 100%;">
            <span v-if="verifyingKey" class="loading loading-dots loading-xl"></span>
            <span v-if="!verifyingKey">Verify Key</span>      
            </button>         
            <div class="flex justify-center">
            <span class="text-[#e62525] text-xs font-semibold">NOTE: We Don't store your work mail. Its for one time company verification. All communications will be done to your personal mail.</span>   
            </div>
        
        <label class="text-xl text-white font-semibold flex justify-center" >Resume/CV - Pdf</label>                       
        <div class="flex flex-col" style="justify-content: space-between;">
            <input type="file"  @change="captureFile" accept=".pdf,application/pdf" class="file-input" style="width: 100%;">            
            <div class="flex flex-row" :style= "data.resume_uploaded ? 'justify-content: space-between;': 'justify-content: space-evenly;'">
            <button ref="uploadBtn" style="width: 49%; height: 2rem;" name = "upload" @click="upload(this.resume)" class="bg-[#1a73e8] mt-2 mb-2 text-white text-sm font-semibold rounded-md flex items-center justify-center">
            <span v-if="uploading" class="loading loading-dots loading-xl"></span>
            <span v-if="!uploading">Upload</span>   
            </button>          
            <a style="width: 49%;" v-if="data.resume_uploaded" :href="`${RESUME_BASE_URL}/${data.id}.pdf?ts=${Date.now()}`" target="_blank" name = "download" class="bg-white flex items-center justify-center mt-2 mb-2 text-black text-sm font-semibold rounded-md">View Resume</a>          
            </div>
        </div>
          <span></span><span></span>
          <span></span><span></span>
          <span></span><span></span>
          <span></span><span></span>
          <span></span><span></span>
        </fieldset>
    </div>
</template>

<script>
import { apiCall, RESUME_BASE_URL, validEmail } from '@/js/main';
import loadingSpinner from './loading.vue';

const initial = {
        email: "",
        email_verified: false,
        work_email_verified: false,
      }

export default {
  name: "profilePage",
  components:{
    loadingSpinner: loadingSpinner
  },
  data(){
    return {
      data: { ...initial },
      password: "",
      work_email: "",
      work_email_verification_key: "",
      loading: true,
      loadingname: 'Loading',
      resume: null,
      RESUME_BASE_URL: RESUME_BASE_URL,
      verify_with_key: false,
      changingEmail: false,
      changingPassword: false,
      verifyingKey: false,
      verifying: false,
      uploading: false,
      showPassword: false,
      currentEmail: ''

    }
  },
  methods:{
    togglePassword() {
        this.showPassword = !this.showPassword
      },
    async changePassword(){

      if (this.password.length < 8){
        this.$emit('push-alert', false, "Password must have alteast 8 characters")
      }
      else if (this.password.length > 30){
        this.$emit('push-alert', false, "Password must have max 30 characters")
      }
      else if (this.password.includes(" ")){
        this.$emit('push-alert', false, "Password must not have whitespace")
      }      
      else{
      const input =  this.$refs.changePasswordBtn
      input.disabled = true
      this.changingPassword = true
      var data = await apiCall("/user/change-password", "PUT", {email: this.data.email, password: this.password})
      if (data.success){
        this.$emit('push-alert', true, "Password Updated")
      }
      else{
        this.$emit('push-alert', false, data.error_message)
      }
      input.disabled = false
      this.changingPassword = false
    }
    },
    async verify(){

    if (validEmail(this.work_email)){
      const input =  this.$refs.verifyBtn
      input.disabled = true
      this.verifying = true
      var data = await apiCall("/user/verify-email", "POST", {email: this.work_email, type: "W"})
      if (data.success){
        this.$emit('push-alert', true, "Verification link sent")
      }
      else{
        this.$emit('push-alert', false, data.error_message)
      }
     input.disabled = false
     this.verifying = false
    }
    else{
      this.$emit('push-alert', false, "Invalid email address")
    }
  },
    async verifyKey(){
      if (this.work_email_verification_key == ""){
        this.$emit('push-alert', false, "No value provided")
      } 
      else{
      const input =  this.$refs.verifyingKeyBtn
      input.disabled = true
      this.verifyingKey = true
      var data = await apiCall("/user/verify-email-key/"+this.work_email_verification_key, "GET",)
      if (data.success){
        this.$emit('push-alert', true, "Verification success")
      }
      else{
        this.$emit('push-alert', false, data.error_message)
      }
      input.disabled = false
      this.verifyingKey = false
    }},    
    async changeEmail(){    
    

    if (validEmail(this.data.email) && this.data.email != this.currentEmail){
      const input =  this.$refs.changeEmailBtn
      input.disabled = true
      this.changingEmail = true
      var data = await apiCall("/user/change-email", "PUT", {email: this.data.email, type: "P"})
      if (data.success){
        this.$emit('push-alert', true, "Verification link sent")
      }
      else{
        this.$emit('push-alert', false, data.error_message)
      }
      input.disabled = false
      this.changingEmail = false}
    
    else if (this.data.email == this.currentEmail){
      this.$emit('push-alert', false, "No Change in mail")
    }
    
    else{
      this.$emit('push-alert', false, "Invalid email address")
    }

    },
    async captureFile(event){
      var file = event.target.files[0]
      
      if (file.size > 5 * 1024 * 1024){
        this.$emit('push-alert', false, "File Size is more that 5MB")
        this.resume = null
      }
      else{
      this.resume = file
      }
    },
    async upload(file) {
      const input =  this.$refs.uploadBtn
      input.disabled = true
      this.uploading = true

      if (this.resume){
      
      var data = await apiCall("/user/resume-upload-url", "GET", null)      
      
      if (data.success == true){
        const presignedUrl = data.data.url
      
        const upload = await fetch(presignedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': file.type || 'application/octet-stream',
            "Cache-Control": "no-cache, no-store, must-revalidate"

          },
          body: file
        })

        if (upload.ok) {
          var res = await apiCall("/user/resume-uploaded", "GET", null)
          if (res.success) {
          this.$emit('push-alert', true, "File uploaded successfully")
          }
          else {
            this.$emit('push-alert', false, "Upload failed")
          }
        } else {
            this.$emit('push-alert', false, "Upload failed")
        }
      } 
      }  
      else{
        this.$emit('push-alert', false, "No File selected")
      }
      this.resume = null
      input.disabled = false
      this.uploading = false
  }
  },
  async beforeMount(){
    window.scrollTo({ top: 0, behavior: 'auto' })
    var data = await apiCall("/user", "GET", null)
        if (data.success == true){
        this.data = data.data
        this.currentEmail = data.data.email
        }        
      this.loading = false
      }
}
</script>
